module.exports = __webpack_public_path__ + "static/media/kotlin.38eff103.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/kotlin.png
// module id = 71
// module chunks = 0